var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"template",style:({
    ..._vm.main_layout.styles,
    ..._vm.parentStyles,
    ..._vm.viewBreakpoint.styles,
  })},[_c('section',{staticClass:"template__body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }